import type { Collection, CollectionFetchOptions, Model, ModelFetchOptions } from 'backbone';

import { INSTANCE_NAMES, getInstance } from '@retail/single-instance-cache';
import { deepClone } from '@luna/utils';
import type {
    UserConfiguration,
    UserConfigurationEntity,
    UserConfigurationSaveStrategy,
} from '@shared/user-configuration';
import { setUserConfigurationSaveStrategy } from '@shared/user-configuration';

interface UserConfigurationModel extends Model<UserConfigurationEntity> {
    fetchSuccess(
        userConfiguration: UserConfiguration[keyof UserConfiguration],
        options?: ModelFetchOptions,
    ): void;
}

interface UserConfigurationCollection extends Collection<UserConfigurationModel> {
    fetchSuccess(userConfiguration: UserConfiguration, options?: CollectionFetchOptions): void;
}

const userConfigurationLegacySaveStrategy: UserConfigurationSaveStrategy = {
    saveAll: (userConfiguration, options) => {
        const userConfigurationCollection = getInstance(
            INSTANCE_NAMES.USER_CONFIGURATION_COLLECTION,
        ) as UserConfigurationCollection;
        userConfigurationCollection.fetchSuccess(
            deepClone(userConfiguration),
            options as CollectionFetchOptions,
        );
    },
    saveOne: (id, userConfiguration, options) => {
        const userConfigurationCollection = getInstance<UserConfigurationCollection>(
            INSTANCE_NAMES.USER_CONFIGURATION_COLLECTION,
        );
        const userConfigurationModel = userConfigurationCollection.find(
            ({ id: userConfigurationId }) => userConfigurationId === id,
        );
        userConfigurationModel.fetchSuccess(
            deepClone(userConfiguration),
            options as CollectionFetchOptions,
        );
    },
};

export const registerUserConfigurationLegacySaveStrategy = () => {
    setUserConfigurationSaveStrategy(userConfigurationLegacySaveStrategy);
};
